import { useCallback, useEffect, useState } from 'react';
import CompanyUserNav from '@/components/pages/company/CompanyUserNav';
import { useSelector } from 'react-redux';
import { RootState } from '@/rootReducer';
import api from '@/api';
import { Modal, Popconfirm, Select } from 'antd';
import { pcompany } from '@/proto/proto';

const CompanyUserListPage = () => {
  const { current: company } = useSelector((state: RootState) => state.company);
  const [companyUserList, setCompanyUserList] = useState<any[]>([]);
  const [visibleModalRole, setVisibleModalRole] = useState(false);
  const [selectUser, setSelectUser] = useState<pcompany.IPbCompanyUser | null>(null);

  const fetch = useCallback(() => {
    api
      .get(`/company/${company.base?.id}/user`)
      .then(({ data }) => {
        setCompanyUserList(data.user);
      })
      .catch(() => {
        setCompanyUserList([]);
      });
  }, [company]);

  useEffect(() => {
    fetch();
  }, [company, fetch]);

  const showModalRole = (index: number) => {
    if (index < companyUserList.length) {
      setSelectUser(companyUserList[index]);
      setVisibleModalRole(true);
    }
  };

  const confirmCompanyUser = (companyUserId: number) => {
    api.post(`/company/${company.base?.id}/user/approve`, 'pcompany.PbCompanyUserApproveRequest', { userId: [companyUserId] }).then(({ data }) => {
      fetch();
    });
  };

  return (
    <div>
      <CompanyUserNav />
      <div className="mt-4 shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
        <table className="min-w-full divide-y divide-gray-200">
          <thead>
            <tr>
              <th className="px-6 py-3 bg-gray-100 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">Name</th>
              <th className="px-6 py-3 bg-gray-100 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">Title</th>
              <th className="px-6 py-3 bg-gray-100 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">Status</th>
              <th className="px-6 py-3 bg-gray-100 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">Role</th>
              <th className="px-6 py-3 bg-gray-100">&nbsp;</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {companyUserList.map((companyUser, index) => (
              <tr key={`company-user-${companyUser.base?.id}`}>
                <td className="px-6 py-4 whitespace-no-wrap">
                  <div className="flex items-center">
                    {/* <div className="flex-shrink-0 h-10 w-10"> */}
                    {/*  <img */}
                    {/*    className="h-10 w-10 rounded-full" */}
                    {/*    src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=facearea&amp;facepad=4&amp;w=256&amp;h=256&amp;q=60" */}
                    {/*    alt="" */}
                    {/*  /> */}
                    {/* </div> */}
                    <div className="ml-4">
                      <div className="text-sm leading-5 font-medium text-gray-900">{companyUser.name}</div>
                      <div className="text-sm leading-5 text-gray-500">{companyUser.email}</div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-no-wrap">
                  <div className="text-sm leading-5 text-gray-900">부서</div>
                  <div className="text-sm leading-5 text-gray-500">직위</div>
                </td>
                <td className="px-6 py-4 whitespace-no-wrap">
                  {!companyUser.statusCode || companyUser.statusCode === 0 ? (
                    <Popconfirm title="승인하시겠습니까?" onConfirm={() => confirmCompanyUser(companyUser.userId)}>
                      <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 cursor-pointer">
                        {companyUser.statusName}
                      </span>
                    </Popconfirm>
                  ) : (
                    <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                      {companyUser.statusName}
                    </span>
                  )}
                </td>
                <td className="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500">{companyUser.typeName}</td>
                <td className="px-6 py-4 whitespace-no-wrap text-right text-sm leading-5 font-medium">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a href="#" className="text-indigo-600 hover:text-indigo-900" onClick={() => showModalRole(index)}>
                    Edit
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Modal visible={visibleModalRole} onCancel={() => setVisibleModalRole(false)}>
          {selectUser && (
            <div className="w-full flex flex-col space-y-3">
              {selectUser.name}
              <br />
              {selectUser.email}
              <Select>
                <Select.Option value={0}>READY</Select.Option>
                <Select.Option value={1}>APPROVE</Select.Option>
                <Select.Option value={2}>REMOVE</Select.Option>
              </Select>
            </div>
          )}
        </Modal>
      </div>
    </div>
  );
};

export default CompanyUserListPage;
